const _ = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
export {
  _ as DEBUG_BUILD
};
